import { Alert, DatePicker, Input, Tooltip } from "antd"
import { CustomInput } from "components/new-stuff/form"
import { Button } from "components"
import FormSectionWrapper from "components/new-stuff/form/FormSectionWrapper"
import { useNavigate } from "react-router-dom"
import { InformationCircleIcon } from "@heroicons/react/24/outline"
import { useMutation } from "@tanstack/react-query"
import { walletAxiosInstance } from "utils/request"
import { useAppNotificationStore, useAuthStore } from "stores"
import { IUserWalletID, KycLevel } from "../interface"
import dayjs from "dayjs"
import { customerIOTrackEvent } from "utils/customerio"

const Bvn = ({
  setCurrentPage,
  formBody,
  setFormBody,
  isActive,
  form,
  Form,
  status,
  walletData,
  currentLevel,
}: {
  setCurrentPage: React.Dispatch<React.SetStateAction<number>>
  formBody: any
  setFormBody: any
  isActive: boolean
  form: any
  Form: any
  status?: "not setup" | "completed" | "pending" | string
  walletData: IUserWalletID | undefined
  currentLevel: null | KycLevel
}) => {
  const navigate = useNavigate()
  const { toast } = useAppNotificationStore()
  const { user } = useAuthStore()
  const EmployeeWalletID = user?.userWalletId

  const bvn = Form.useWatch("bvn", form)
  const firstName = Form.useWatch("bvn_first_name", form)
  const lastName = Form.useWatch("bvn_last_name", form)
  const phoneNumber = Form.useWatch("mobileNumber", form)
  const SelectedDOB = Form.useWatch("birthday", form)

  const onFinish = () => {
    const DOB = dayjs(SelectedDOB).format("YYYY-MM-DD")

    setFormBody({
      ...formBody,
      bvn_firstName: firstName,
      bvn_lastName: lastName,
      bvn,
      bvn_PhoneNumber: phoneNumber,
      dateOfBirth: DOB,
    })

    form
      .validateFields()
      .then((values: any) => {
        if (
          formBody?.bvn_firstName === firstName &&
          formBody?.bvn_lastName === lastName &&
          formBody?.bvn === bvn &&
          formBody?.bvn_PhoneNumber === phoneNumber &&
          formBody?.dateOfBirth === DOB
        ) {
          if (walletData?.data?.pinSet) {
            currentLevel?.level === 2
              ? setCurrentPage(3)
              : navigate(
                  user?.userStatusId === 2 || user?.userStatusId === 3
                    ? "/employee/susp-exit/wallet/cross-border/overview"
                    : "/employee/dashboard/wallet/cross-border/overview"
                )
          } else {
            navigate(
              user?.userStatusId === 2 || user?.userStatusId === 3
                ? "/employee/susp-exit/wallet/create-pin"
                : "/employee/dashboard/wallet/create-pin"
            )
          }
        } else {
          submit({
            bvnFirstName: firstName,
            bvnLastName: lastName,
            walletId: EmployeeWalletID ? EmployeeWalletID : "",
            bvn,
            bvnPhoneNumber: phoneNumber,
            dateOfBirth: DOB,
            provider: user?.walletProvider,
          })
        }
      })
      .catch((errorInfo: any) => {})
  }

  const { isLoading: isLoading, mutate: submit } = useMutation({
    mutationFn: async (body: IBody) => {
      const res: any = await walletAxiosInstance.post(
        `/v1/wallets/kyc/verify-bvn`,
        body
      )

      if (res?.data?.success) {
        return res?.data
      } else {
        return res.response?.data
      }
    },
    onSuccess: (data: any) => {
      if (data.success) {
        data?.data && toast.success(data?.data)
        customerIOTrackEvent("Wallet KYC 2 completed")

        if (walletData?.data?.pinSet) {
          navigate(
            user?.userStatusId === 2 || user?.userStatusId === 3
              ? "/employee/susp-exit/wallet/cross-border/overview"
              : "/employee/dashboard/wallet/cross-border/overview"
          )
        } else {
          navigate(
            user?.userStatusId === 2 || user?.userStatusId === 3
              ? "/employee/susp-exit/wallet/create-pin"
              : "/employee/dashboard/wallet/create-pin"
          )
        }
      } else {
        data?.data && toast.error(data?.data)
        if (data.code === 409) {
          if (walletData?.data?.pinSet) {
            navigate(
              user?.userStatusId === 2 || user?.userStatusId === 3
                ? "/employee/susp-exit/wallet/cross-border/overview"
                : "/employee/dashboard/wallet/cross-border/overview"
            )
          } else {
            navigate(
              user?.userStatusId === 2 || user?.userStatusId === 3
                ? "/employee/susp-exit/wallet/create-pin"
                : "/employee/dashboard/wallet/create-pin"
            )
          }
        }
      }
    },
    onError: (data: any) => {
      data?.response?.data?.message &&
        toast.error(data?.response?.data?.message)

      // To Check if BVN HAS BEEN VERIFIED OR NOT
      if (data?.response?.status === 409) {
        if (walletData?.data?.pinSet) {
          // navigate("/employee/dashboard/wallet/overview")
        } else {
          navigate(
            user?.userStatusId === 2 || user?.userStatusId === 3
              ? "/employee/susp-exit/wallet/create-pin"
              : "/employee/dashboard/wallet/create-pin"
          )
        }
      }
    },
  })

  return (
    <FormSectionWrapper
      isActive={isActive}
      name="Tier 2 KYC (BVN)"
      title="Tier 2 KYC (BVN)"
      subtitle="You have a daily withdrawal limit of up to N1,000,000.00"
      form={form}
      layout="vertical"
      showDropdown
      onDropDown={() => {
        isActive ? setCurrentPage(0) : setCurrentPage(2)
      }}
      status={status}
      footerBtns={
        <div className="flex  items-center justify-between ">
          <div className="flex items-center">
            <Button
              color="secondary"
              type="button"
              onClick={() => {
                if (walletData?.data?.pinSet) {
                  navigate(
                    user?.userStatusId === 2 || user?.userStatusId === 3
                      ? "/employee/susp-exit/wallet/cross-border/overview"
                      : "/employee/dashboard/wallet/cross-border/overview"
                  )
                } else {
                  navigate(
                    user?.userStatusId === 2 || user?.userStatusId === 3
                      ? "/employee/susp-exit/wallet/create-pin"
                      : "/employee/dashboard/wallet/create-pin"
                  )
                }
              }}
            >
              Skip to Wallet{" "}
            </Button>
            {currentLevel?.level === 1 && (
              <Tooltip
                title={
                  "If you skip to wallet, you won't be able to make transactions outside PaidHR. Please provide your BVN for inter-bank transfers"
                }
              >
                <InformationCircleIcon className="ml-1 w-4 h-4" />
              </Tooltip>
            )}
          </div>

          <div className="flex justify-end items-center gap-4">
            <Button
              color="secondary"
              type="button"
              onClick={() => {
                setCurrentPage(1)
              }}
            >
              Previous
            </Button>

            <Button
              color="primary"
              type="button"
              onClick={onFinish}
              submitting={isLoading}
            >
              Submit
            </Button>
          </div>
        </div>
      }
      initialValues={{
        bvn_first_name: formBody?.bvn_firstName,
        bvn_last_name: formBody?.bvn_lastName,
        bvn: formBody?.bvn,
        birthday: formBody?.dateOfBirth,
        mobileNumber: formBody?.bvn_PhoneNumber,
      }}
    >
      <div className="space-y-6">
        <div className="  px-4 md:px-6 lg:px-8 xl:px-[60px] pb-5">
          <h6 className=" text-padeBlack font-bold">What you get in Tier 2</h6>
          <p>
            You get a PaidHR bank account that can be used for inter bank
            transactions
          </p>

          <div className="border border-[#6c7a9326] mt-[34px] rounded-5px ">
            <div className="px-4 lg:px-[29px] py-[21px] border-b-2 border-[#6c7a9326] ">
              <h6 className=" text-padeBlack font-bold">Link BVN</h6>
            </div>
            <div className="w-full px-4 lg:px-[29px] py-6">
              <Alert
                message={
                  "We take your security very seriously and so we will not store any information that may be an infringement on your privacy. What this means is that we will not have access to your other bank accounts or financial history. Your information is safe with us."
                }
                type="info"
                showIcon
                className="  font-avenir text-neutral500 text-sm w-full flex justify-between items-center "
              />

              <div className="mt-10 flex flex-col md:grid grid-cols-2 gap-x-10">
                <CustomInput
                  label={"First name"}
                  name="bvn_first_name"
                  required
                  disabled={
                    status === "completed" && formBody?.bvn_firstName
                      ? true
                      : false
                  }
                />
                <CustomInput
                  label={"Last name"}
                  name="bvn_last_name"
                  required
                  disabled={
                    status === "completed" && formBody?.bvn_lastName
                      ? true
                      : false
                  }
                />
                {/* ---- Birthday ---- */}
                <Form.Item
                  label={
                    <span className="text-padeBlack font-circular text-sm  ">
                      Date of birth
                    </span>
                  }
                  name="birthday"
                  rules={[
                    { required: true, message: "Please enter this field!" },
                  ]}
                >
                  <DatePicker
                    className="w-full"
                    format={"YYYY-MM-DD"}
                    disabled={
                      status === "completed" && formBody?.dateOfBirth
                        ? true
                        : false
                    }
                  />
                </Form.Item>

                {/* Phone number */}
                <Form.Item
                  name="mobileNumber"
                  label={
                    <span className="text-padeBlack font-circular text-sm  ">
                      {" "}
                      Phone number
                    </span>
                  }
                  rules={[
                    {
                      required: true,
                      message: "Please input your phone number!",
                    },
                  ]}
                  className="mb-2"
                >
                  <Input
                    placeholder="234 xxxxxxxx"
                    type="number"
                    disabled={
                      status === "completed" && formBody?.bvn_PhoneNumber
                        ? true
                        : false
                    }
                    maxLength={15}
                  />
                </Form.Item>
                <div className="col-span-2">
                  <Form.Item
                    label={
                      <span className="text-padeBlack font-circular flex items-center">
                        BVN
                        <Tooltip title="Dial *565*0# if you don’t remember your BVN">
                          <InformationCircleIcon className="w-4 h-4 ml-1" />
                        </Tooltip>
                      </span>
                    }
                    name="bvn"
                    rules={[
                      { required: true, message: "Please enter this field" },
                      { pattern: /^\d{11}$/, message: "BVN must be 11 digits" },
                    ]}
                  >
                    <Input
                      type="text"
                      placeholder="11 digits"
                      className="font-circular text-neutral400"
                      disabled={
                        status === "completed" && formBody?.bvn ? true : false
                      }
                    />
                  </Form.Item>
                </div>
                <p className="font-circular text-sm  text-padeBlack col-span-2">
                  Once you submit this information, it cannot be edited. Please
                  verify all details thoroughly before clicking Submit.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </FormSectionWrapper>
  )
}

export default Bvn

interface IBody {
  bvnFirstName?: string
  bvnLastName?: string
  walletId: string
  bvn: string
  bvnPhoneNumber: string
  dateOfBirth: string
  provider: string | null | undefined
}
